export enum ModalActionTypes {
  View = 0,
  Edit = 1,
  Delete = 2,
  Create = 3,
  Send = 4,
}
